import {SpriteView} from './SpriteView'
import {ViewAnimationController} from './ViewAnimationController'
import {PIXI} from '@colonist/pixi'
import {ViewAnimationControllerAdapter} from './animation/ViewAnimationControllerAdapter'

export class MovingSpriteView extends SpriteView {
    animationController: ViewAnimationController

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, texture: PIXI.Texture, padding: number = 0) {
        super(x, y, w, h, container, texture, padding)

        this.animationController = new ViewAnimationControllerAdapter(this)
    }
}
